import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IOurExpertise } from "../ourExpertiseModel";

export const getAllOurExpertises = createAsyncThunk(
  "OurExpertise/FindAllOurExpertise",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/OurExpertise/FindAllOurExpertise`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Our Expertises:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createOurExpertise = createAsyncThunk(
  "OurExpertise/AddOurExpertise",
  async (OurExpertiseData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/OurExpertise/AddOurExpertise`,
        OurExpertiseData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating our expertise:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateOurExpertise = createAsyncThunk(
  "OurExpertise/EditOurExpertise",
  async (OurExpertiseData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/OurExpertise/EditOurExpertise`,
        OurExpertiseData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating our expertise:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteOurExpertise = createAsyncThunk(
  "OurExpertise/DeleteOurExpertise",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/OurExpertise/DeleteOurExpertise`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting our expertise:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getOurExpertiseByID = createAsyncThunk(
  "OurExpertise/FindByIDOurExpertise",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/OurExpertise/FindByIDOurExpertise`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Title: result.Title,
        Description: result.Description,
        ExpertiseImage: result.ExpertiseImage,
        IsActive: result?.IsActive ? 1 : 2,
      } as IOurExpertise;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching our expertise:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveOurExpertises = createAsyncThunk(
  "OurExpertise/FindAllActiveOurExpertise",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/OurExpertise/FindAllActiveOurExpertise`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching our expertises:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveOurExpertise = createAsyncThunk(
  "OurExpertise/ActiveInActiveOurExpertise",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/OurExpertise/ActiveInActiveOurExpertise`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive our expertise:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
